import { render } from "./orderDetails.vue?vue&type=template&id=0b9ec421"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"

import "./orderDetails.vue?vue&type=style&index=0&id=0b9ec421&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__